<div class="buttons-container">
    <ng-content select="[content-buttons]"></ng-content>
</div>
<div class="filters-container1">
    <ng-content select="[content-filters]"></ng-content>
</div>